<template>
  <!-- 顶部设置按钮-网站qq群配置 -->
  <div class="config">
    <h1>网站配置</h1>
    <h4>
      正在使用：<span style="color: rgb(48, 228, 108)">{{ inUse }}</span>
    </h4>
    <div class="group" v-if="dataList">
      <el-card class="box-card" v-for="item in dataList" :key="item.id">
        <div slot="header" class="clearfix">
          <span>{{ item.id }}群</span>
          <el-button style="float: right" type="primary" @click="submit(item)"
            >使用</el-button
          >
        </div>
        <el-form :model="item" label-width="100px">
          <el-form-item label="QQ群号">
            <el-input v-model="item.qq_number"></el-input>
          </el-form-item>
          <el-form-item label="QQ群地址">
            <el-input v-model="item.qq"></el-input>
          </el-form-item>
          <el-form-item prop="image" label="QQ群二维码">
            <imgUpload v-model="item.url" widthNum="130px"></imgUpload>
          </el-form-item>
          <el-form-item label="客服1">
            <el-input v-model="item.qq_kefu1"></el-input>
          </el-form-item>
          <el-form-item label="客服2">
            <el-input v-model="item.qq_kefu2"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="setConfig(item)"
              >保存修改</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
      <!-- <el-card class="box-card" v-if="dataList[0]">
        <div slot="header" class="clearfix">
          <span>1群</span>
          <el-button
            style="float: right"
            type="primary"
            @click="submit(dataList[0])"
            >使用</el-button
          >
        </div>
        <el-form :model="dataList[0]" label-width="100px">
          <el-form-item label="QQ群号">
            <el-input v-model="dataList[0].qq_number"></el-input>
          </el-form-item>
          <el-form-item label="QQ群地址">
            <el-input v-model="dataList[0].qq"></el-input>
          </el-form-item>
          <el-form-item prop="image" label="QQ群二维码">
            <imgUpload v-model="dataList[0].url" widthNum="130px"></imgUpload>
          </el-form-item>
          <el-form-item label="客服1">
            <el-input v-model="dataList[0].qq_kefu1"></el-input>
          </el-form-item>
          <el-form-item label="客服2">
            <el-input v-model="dataList[0].qq_kefu2"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="setConfig(dataList[0])"
              >保存修改</el-button
            >
          </el-form-item>
        </el-form>
      </el-card> -->
      <!-- <el-card class="box-card" v-if="dataList[1]">
        <div slot="header" class="clearfix">
          <span>2群</span>
          <el-button
            style="float: right"
            type="primary"
            @click="submit(dataList[1])"
            >使用</el-button
          >
        </div>
        <el-form :model="dataList[1]" label-width="100px">
          <el-form-item label="QQ群号">
            <el-input v-model="dataList[1].qq_number"></el-input>
          </el-form-item>
          <el-form-item label="QQ群地址">
            <el-input v-model="dataList[1].qq"></el-input>
          </el-form-item>
          <el-form-item prop="image" label="QQ群二维码">
            <imgUpload v-model="dataList[1].url" widthNum="130px"></imgUpload>
          </el-form-item>
          <el-form-item label="客服1">
            <el-input v-model="dataList[1].qq_kefu1"></el-input>
          </el-form-item>
          <el-form-item label="客服2">
            <el-input v-model="dataList[1].qq_kefu2"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="setConfig(dataList[1])"
              >保存修改</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card" v-if="dataList[2]">
        <div slot="header" class="clearfix">
          <span>3群</span>
          <el-button
            style="float: right"
            type="primary"
            @click="submit(dataList[2])"
            >使用</el-button
          >
        </div>
        <el-form :model="dataList[2]" label-width="100px">
          <el-form-item label="QQ群号">
            <el-input v-model="dataList[2].qq_number"></el-input>
          </el-form-item>
          <el-form-item label="QQ群地址">
            <el-input v-model="dataList[2].qq"></el-input>
          </el-form-item>
          <el-form-item prop="image" label="QQ群二维码">
            <imgUpload v-model="dataList[2].url" widthNum="130px"></imgUpload>
          </el-form-item>
          <el-form-item label="客服1">
            <el-input v-model="dataList[2].qq_kefu1"></el-input>
          </el-form-item>
          <el-form-item label="客服2">
            <el-input v-model="dataList[2].qq_kefu2"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="setConfig(dataList[2])"
              >保存修改</el-button
            >
          </el-form-item>
        </el-form>
      </el-card> -->
    </div>
  </div>
</template>

<script>
import imgUpload from '../../components/common/ImgUpload'
import { getData, patchData } from '../../http'
export default {
  components: {
    imgUpload
  },
  data() {
    return {
      inUse: '',
      dataList: undefined,
    }
  },
  methods: {
    submit(val) {
      //使用
      let params = val
      params.status = 1
      patchData(`qq_config/${val.id}`, params).then(res => {
        this.$message.success('修改成功')
        this.getConfig()//刷新数据
      })
    },
    getConfig() {
      //获取数据
      getData('qq_config').then(res => {
        if (res) {
          this.dataList = JSON.parse(JSON.stringify(res.data))
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].status === 1) {
              this.inUse = res.data[i].id + '群'
            }
          }
        }
      })
    },
    setConfig(val) {
      //保存修改
      let params = val
      params.status = undefined //目的是不传status
      patchData(`qq_config/${val.id}`, params).then(res => {
        this.$message.success('修改成功')
        this.getConfig()//刷新数据
      })
    }
  },
  created() {
    this.getConfig()
  }
}
</script>

<style lang="less">
.config {
  width: 400px;
  h1 {
    margin-bottom: 20px;
  }
  .group {
    display: flex;
    .box-card {
      flex-shrink: 0;
      width: 400px;
      margin: 10px;
      color: rgb(48, 228, 108);
    }
  }
}
</style>
